import { render, staticRenderFns } from "./ArticleCarousel.vue?vue&type=template&id=68c79f47&"
import script from "./ArticleCarousel.vue?vue&type=script&lang=js&"
export * from "./ArticleCarousel.vue?vue&type=script&lang=js&"
import style1 from "./ArticleCarousel.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})
